import React, { PureComponent, Fragment } from 'react';
import { Row, Nav, NavItem, TabContent, TabPane, Form, FormGroup, Label, Card, CardTitle, CardBody, Table, Button, Modal, ModalHeader, ModalBody, ModalFooter, Input, CustomInput } from 'reactstrap';
import Switch from 'rc-switch';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import LoadingOverlay from 'Components/LoadingOverlay';
import classnames from 'classnames';
import { Map, List } from 'immutable';
import CustomFormGroup from 'Components/CustomFormGroup';
import { Colxx } from 'Components/CustomBootstrap';
import { NotificationManager } from 'Components/ReactNotifications';
import {
	warehousesUpdate,
	warehousesGetDetails,
	warehousesGetOptions,
	warehousesGetIPWhitelists,
	warehousesBatchUpdateIPWhitelists,
	errorReset,
} from 'Redux/actions';
import * as warehousesReducer from 'Redux/warehouses/reducer';
import BreadcrumbContainer from 'Components/BreadcrumbContainer';
import IntlMessages from 'Util/IntlMessages';

class PageWarehouse extends PureComponent {
	constructor(props) {
		super(props);
		this.defaultIPWhitelists = new Map({
			id: null,
			ip_address: '',
			enabled: true,
		});
		this.state = {
			activeTab: 'details',
			showModalIP: false,
			currentIndex: null,
			warehouse: new Map({
				wh_code: null,
				wh_status: 'A',
				login_url: null,
				wechat_id: null,
				email: null,
				warehouse_type: null,
				mall_name: null,
				company: null,
				warehouse_groups: [],
				stock_transfer_destinations: [],
				retail_group: null,
				document_types: [],
				payment_methods: [],
				show_barcode: null,
				show_footer: null,
				show_exchange_rate: null,
				default_order_type_r: null,
				set_currency_to_mop: null,
				hide_warehouse_name: null,
				invoice_template: null,
				invoice_copies: [],
				enable_emergency: false,
				emergency_time_from: null,
				emergency_time_to: null,
				assigned_user: null,
				enable_business_hour: null,
				business_hour_from: null,
				business_hour_to: null,
				disable_sales_order_outside_business_hour: null,
				disable_service_memo_outside_business_hour: null,
				disable_void_order_outside_business_hour: null,
				disable_return_item_outside_business_hour: null,
				disable_redeem_q_to_r_outside_business_hour: null,
				disable_deposit_refund_outside_business_hour: null,
			}),
			ipWhitelists: new List(),
			modalData: this.defaultIPWhitelists,
		};
		this.fields = {
			details: [
				{ id: 'wh_desc', label: 'Warehouse' },
				{ id: 'wh_code', label: 'Shop Code' },
				{ id: 'wh_type', label: 'Type' },
				{ id: 'wh_tel', label: 'Phone' },
				{ id: 'wh_fax', label: 'Fax' },
				{ id: 'wh_add', label: 'Address' },
			],
			detailsInput: [
				{ id: 'login_url', type: 'text', label: 'Login URL' },
				{ id: 'wechat_id', type: 'text', label: 'WeChat ID' },
				{ id: 'email', type: 'text', label: 'E-mail' },
				{ id: 'mall_name', type: 'text', label: 'Mall Name' },
			],
			detailsInvoice: [
				{ id: 'show_barcode', type: '', label: 'Show barcode in invoice', onChange: this.onToggleSwitchHandler.bind(this, 'show_barcode') },
				{ id: 'show_footer', type: '', label: 'Show footer in invoice', onChange: this.onToggleSwitchHandler.bind(this, 'show_footer') },
				// { id: 'default_order_type_r', type: '', label: 'Set default order type to R', onChange: this.onToggleSwitchHandler.bind(this, 'default_order_type_r') },
				{ id: 'show_exchange_rate', type: '', label: 'Show exchange rate in payment page', onChange: this.onToggleSwitchHandler.bind(this, 'show_exchange_rate') },
				{ id: 'set_currency_to_mop', type: '', label: 'Set currency to MOP', onChange: this.onToggleSwitchHandler.bind(this, 'set_currency_to_mop') },
				{ id: 'hide_warehouse_name', type: '', label: 'Hide warehouse name in invoice', onChange: this.onToggleSwitchHandler.bind(this, 'hide_warehouse_name') },
			],
			detailsSelect: [
				{ id: 'warehouse_type', label: 'Warehouse Type', isMulti: false, onChange: this.onChangeMultipleHandler.bind(this, 'warehouse_type') },
				{ id: 'company', label: 'Company', isMulti: false, onChange: this.onChangeMultipleHandler.bind(this, 'company') },
				{ id: 'wh_status', label: 'Status', isMulti: false, onChange: this.onChangeMultipleHandler.bind(this, 'wh_status') },
			],
			group: [
				{ id: 'warehouse_groups', label: 'Warehouse Groups', isMulti: true, onChange: this.onChangeMultipleHandler.bind(this, 'warehouse_groups') },
				{ id: 'stock_transfer_destinations', label: 'Available Stock Transfer Destinations', isMulti: true, onChange: this.onChangeMultipleHandler.bind(this, 'stock_transfer_destinations') },
				{ id: 'retail_group', label: 'Price Group', isMulti: false, onChange: this.onChangeMultipleHandler.bind(this, 'retail_group') },
			],
			document_type: [
				{ id: 'document_types', label: 'Document Types', desc: 'Allowed Document Type', isMulti: true, onChange: this.onChangeMultipleHandler.bind(this, 'document_types') },
			],
			payment_method: [
				{ id: 'payment_methods', label: 'Payment Methods', desc: 'Applied Payment Method', isMulti: true, onChange: this.onChangeMultipleHandler.bind(this, 'payment_methods') },
			],
			invoice_template: [
				{ id: 'invoice_template', label: 'Invoice Template', desc: 'Invoice Template', isMulti: false, onChange: this.onChangeMultipleHandler.bind(this, 'invoice_template') },
				{ id: 'invoice_copies', label: 'Copy', desc: 'Copy', type: 'checkbox', isMulti: true, onChange: this.onChangeMultipleHandler.bind(this, 'invoice_copies') },
			],
			emergency: [
				{ id: 'enable_emergency', type: 'switch', label: 'Enable No IP Filter Mode', onChange: this.onToggleSwitchHandler.bind(this, 'enable_emergency') },
				{ id: 'emergency_time_from', type: 'time' , label: 'Time Range (From)' },
				{ id: 'emergency_time_to', type: 'time' , label: 'Time Range (To)' },
				{ id: 'assigned_user', type: 'select', label: 'Assigned User', onChange: this.onChangeMultipleHandler.bind(this, 'assigned_user') }
			],
			business_hour: [
				{ id: 'enable_business_hour', type: 'switch', label: 'Enable Out of Business Hour Restriction', onChange: this.onToggleSwitchHandler.bind(this, 'enable_business_hour') },
				{ id: 'business_hour_from', type: 'time' , label: 'Business Hour (From)' },
				{ id: 'business_hour_to', type: 'time' , label: 'Business Hour (To)' },
				{ id: 'out_of_business_hour_restrictuion', type: 'title', label: 'Restrict the following functions outside business hour' },
				{ id: 'disable_sales_order_outside_business_hour', type: 'switch', label: 'Create sales order', onChange: this.onToggleSwitchHandler.bind(this, 'disable_sales_order_outside_business_hour') },
				{ id: 'disable_service_memo_outside_business_hour', type: 'switch', label: 'Create service memo', onChange: this.onToggleSwitchHandler.bind(this, 'disable_service_memo_outside_business_hour') },
				{ id: 'disable_void_order_outside_business_hour', type: 'switch', label: 'Void order', onChange: this.onToggleSwitchHandler.bind(this, 'disable_void_order_outside_business_hour') },
				{ id: 'disable_return_item_outside_business_hour', type: 'switch', label: 'Return item', onChange: this.onToggleSwitchHandler.bind(this, 'disable_return_item_outside_business_hour') },
				{ id: 'disable_redeem_q_to_r_outside_business_hour', type: 'switch', label: 'Redeem order', onChange: this.onToggleSwitchHandler.bind(this, 'disable_redeem_q_to_r_outside_business_hour') },
				{ id: 'disable_deposit_refund_outside_business_hour', type: 'switch', label: 'Deposit refund', onChange: this.onToggleSwitchHandler.bind(this, 'disable_deposit_refund_outside_business_hour') },
			],
		};
		this.breadcrumb = [
			{ id: 'menu.warehouse', href: '/warehouse/list' },
			{ id: 'menu.warehouse.warehouse-list', href: '/warehouse/list' },
			{ id: 'warehouse.heading', href: `/warehouse/${this.getId(props) ? `edit/${this.getId(props)}` : 'create'}` },
		];
		this.getId = this.getId.bind(this);
		this.onChangeHandler = this.onChangeHandler.bind(this);
		this.onChangeCheckboxHandler = this.onChangeCheckboxHandler.bind(this);
		this.onToggleIPWhitelistHandler = this.onToggleIPWhitelistHandler.bind(this);
		this.onEditIPWhitelistHandler = this.onEditIPWhitelistHandler.bind(this);
		this.onDeleteIPWhitelistHandler = this.onDeleteIPWhitelistHandler.bind(this);
		this.onSelectDetailsTabHandler = this.onSelectTabHandler.bind(this, 'details');
		this.onSelectBusinessHourTabHandler = this.onSelectTabHandler.bind(this, 'businessHour');
		this.onSelectIPTabHandler = this.onSelectTabHandler.bind(this, 'ip');
		this.onSelectEmergencyTabHandler = this.onSelectTabHandler.bind(this, 'emergency');
		this.onToggleModalIPHandler = this.onToggleModalIPHandler.bind(this);
		this.onCancelModalIPHandler = this.onCancelModalIPHandler.bind(this);
		this.onConfirmModalIPHandler = this.onConfirmModalIPHandler.bind(this);
		this.onChangeModalIPAddressHandler = this.onChangeModalIPAddressHandler.bind(this);
		this.onChangeModalDescHandler = this.onChangeModalDescHandler.bind(this);
		this.onChangeModalStatusHandler = this.onChangeModalStatusHandler.bind(this);
		this.onSubmitHandler = this.onSubmitHandler.bind(this);
		this.renderField = this.renderField.bind(this);
		this.renderSelect = this.renderSelect.bind(this);
		this.renderSwitch = this.renderSwitch.bind(this);
	}

	componentDidMount() {
		const id = this.getId();
		if (id) {
			this.props.warehousesGetDetails(id);
			this.props.warehousesGetIPWhitelists(id);
		}
		this.props.warehousesGetOptions();
		this.props.errorReset('warehouse');
		this.props.errorReset('warehouseIPWhitelists');
	}

	componentDidUpdate(prevProps) {
		const id = this.getId();
		if (id) {
			const prevWarehouse = prevProps.warehouse.get(id);
			const warehouse = this.props.warehouse.get(id);
			if (warehouse && warehouse !== prevWarehouse) {
				const warehouseType = warehouse.warehouse_type
					? (typeof warehouse.warehouse_type === 'string'
						? { value: warehouse.warehouse_type, label: warehouse.warehouse_type }
						: warehouse.warehouse_type)
					: { value: 'Not Boutique', label: 'Not Boutique' };
				this.setState({
					warehouse: this.state.warehouse.merge(warehouse).set('warehouse_type', warehouseType),
				});
			}

			const prevIPWhitelists = prevProps.ipWhitelists.get(id);
			const ipWhitelists = this.props.ipWhitelists.get(id);
			if (ipWhitelists && ipWhitelists !== prevIPWhitelists) {
				this.setState({
					ipWhitelists: new List(ipWhitelists.map((ipWhitelist) => this.defaultIPWhitelists.merge(ipWhitelist))),
				});
			}
		}

		const current = this.props.current;
		const prevStatus = prevProps.status.get('warehouse');
		const status = this.props.status.get('warehouse');
		if (status && prevStatus !== status) {
			switch (status) {
			case 'submitted': {
				NotificationManager.success(
					`The warehouse is ${id ? 'updated' : 'created'} successfully.`,
					`Warehouse ${id ? 'Updated' : 'Created'}`
				);
				this.props.history.push(`/app/warehouse/edit/${current}`);
			}
				break;
			case 'has-errors':
				NotificationManager.error(
					`Error occured! The warehouse is NOT ${id ? 'updated' : 'created'}.`,
					`Warehouse ${id ? 'Updated' : 'Created'} Failed`
				);
				break;
			}
		}
	}

	getId(props = null) {
		if (!props) {
			props = this.props;
		}
		return props.match.params.warehouseId;
	}

	onChangeHandler(e) {
		let { warehouse } = this.state;
		this.setState({
			warehouse: warehouse.set(e.target.id, e.target.value),
		});
	}

	getWarehouseTypeValue(warehouse) {
		const warehouseType = warehouse.get('warehouse_type');
		if (!warehouseType) {
			return 'Not Boutique';
		}
		if (typeof warehouseType === 'string') {
			return warehouseType;
		}
		if (warehouseType.value) {
			return warehouseType.value;
		}
		return 'Not Boutique';
	}

	onChangeCheckboxHandler(e) {
		const { warehouse } = this.state;
		let { id, value } = e.target;
		id = id.replace(/-[\d]+$/, '');
		value = parseInt(value);
		let tmp = [];
		if (warehouse.get(id)) {
			tmp = [...warehouse.get(id)];
		}
		if (tmp.includes(value)) {
			const index = tmp.indexOf(value);
			tmp.splice(index, 1);
		} else {
			tmp.push(value);
		}
		tmp.sort();

		this.setState({
			warehouse: warehouse.set(id, tmp),
		});
	}

	onToggleIPWhitelistHandler(index, value) {
		const { ipWhitelists } = this.state;
		this.setState({
			ipWhitelists: ipWhitelists.set(
				index,
				ipWhitelists.get(index).set('enabled', value)
			),
		});
	}

	onEditIPWhitelistHandler(index) {
		const { ipWhitelists } = this.state;
		this.setState({
			showModalIP: true,
			currentIndex: index,
			modalData: ipWhitelists.get(index),
		});
	}

	onDeleteIPWhitelistHandler(index) {
		if (confirm('Are you sure to delete this IP address?')) {
			const { ipWhitelists } = this.state;
			this.setState({
				ipWhitelists: ipWhitelists.delete(index),
			});
		}
	}

	onSelectTabHandler(tab) {
		this.setState({
			activeTab: tab,
		});
	}

	onChangeMultipleHandler(field, selectedOptions) {
		const { warehouse } = this.state;
		if (field === 'warehouse_type') {
			const isBoutique = selectedOptions && selectedOptions.value === 'Boutique';
			let nextWarehouse = warehouse.set(field, selectedOptions);
			if (!isBoutique) {
				nextWarehouse = nextWarehouse.set('mall_name', null);
			} else if (!warehouse.get('mall_name')) {
				nextWarehouse = nextWarehouse.set('mall_name', warehouse.get('wh_desc') || null);
			}
			this.setState({
				warehouse: nextWarehouse,
			});
			return;
		}
		this.setState({
			warehouse: warehouse.set(field, selectedOptions),
		});
	}

	onToggleSwitchHandler(field) {
		const { warehouse } = this.state;
		const value = warehouse.get(field);
		this.setState({
			warehouse: warehouse.set(field, !value),
		});
	}

	onToggleModalIPHandler() {
		const { showModalIP } = this.state;
		this.setState({
			showModalIP: !showModalIP,
			currentIndex: null,
		});
	}

	onCancelModalIPHandler(e) {
		e.preventDefault();
		this.setState({
			showModalIP: false,
			currentIndex: null,
			modalData: this.defaultIPWhitelists,
		});
	}

	onConfirmModalIPHandler(e) {
		e.preventDefault();
		const { modalData, ipWhitelists, currentIndex } = this.state;
		this.setState({
			showModalIP: false,
			currentIndex: null,
			modalData: this.defaultIPWhitelists,
			ipWhitelists: currentIndex === null ? ipWhitelists.push(modalData) : ipWhitelists.set(currentIndex, modalData),
		});
	}

	onChangeModalIPAddressHandler(e) {
		const { modalData } = this.state;
		this.setState({
			modalData: modalData.set('ip_address', e.target.value),
		});
	}

	onChangeModalDescHandler(e) {
		const { modalData } = this.state;
		this.setState({
			modalData: modalData.set('desc', e.target.value),
		});
	}

	onChangeModalStatusHandler(value) {
		const { modalData } = this.state;
		this.setState({
			modalData: modalData.set('enabled', value),
		});
	}

	onSubmitHandler(e) {
		e.preventDefault();
		const id = this.getId();
		let warehouse = this.state.warehouse.toJS();
		let data = {};
		data.wh_code = id;
		data.wh_status = warehouse.wh_status ? warehouse.wh_status.value : null;
		data.login_url = warehouse.login_url;
		data.wechat_id = warehouse.wechat_id;
		data.email = warehouse.email;
		data.warehouse_type = warehouse.warehouse_type ? warehouse.warehouse_type.value : 'Not Boutique';
		data.mall_name = data.warehouse_type === 'Boutique'
			? ((warehouse.mall_name && warehouse.mall_name.trim()) || (warehouse.wh_desc ? warehouse.wh_desc.trim() : null))
			: null;
		data.company_id = warehouse.company ? warehouse.company.value : null;
		data.warehouse_group_ids = warehouse.warehouse_groups.map((warehouseGroup) => warehouseGroup.value);
		data.stock_transfer_destination_ids = warehouse.stock_transfer_destinations.map((warehouseGroup) => warehouseGroup.value);
		data.retail_group = warehouse.retail_group ? warehouse.retail_group.value.trim() : null;
		data.doc_types = warehouse.document_types.map((document_type) => document_type.value.trim());
		data.pay_codes = warehouse.payment_methods.map((payment_method) => payment_method.value.trim());
		data.show_barcode = warehouse.show_barcode;
		data.show_footer = warehouse.show_footer;
		data.show_exchange_rate = warehouse.show_exchange_rate;
		data.set_currency_to_mop = warehouse.set_currency_to_mop;
		data.hide_warehouse_name = warehouse.hide_warehouse_name;
		data.default_order_type_r = warehouse.default_order_type_r;
		data.invoice_template = warehouse.invoice_template ? warehouse.invoice_template.value.trim() : null;
		data.invoice_copies = warehouse.invoice_copies ? warehouse.invoice_copies : [];
		data.enable_emergency = warehouse.enable_emergency;
		data.emergency_time_from = warehouse.emergency_time_from;
		data.emergency_time_to = warehouse.emergency_time_to;
		data.assigned_user = warehouse.assigned_user ? warehouse.assigned_user.value.trim() : null;
		data.enable_business_hour = warehouse.enable_business_hour;
		data.business_hour_from = warehouse.business_hour_from;
		data.business_hour_to = warehouse.business_hour_to;
		data.disable_sales_order_outside_business_hour = warehouse.disable_sales_order_outside_business_hour;
		data.disable_service_memo_outside_business_hour = warehouse.disable_service_memo_outside_business_hour;
		data.disable_void_order_outside_business_hour = warehouse.disable_void_order_outside_business_hour;
		data.disable_return_item_outside_business_hour = warehouse.disable_return_item_outside_business_hour;
		data.disable_redeem_q_to_r_outside_business_hour = warehouse.disable_redeem_q_to_r_outside_business_hour;
		data.disable_deposit_refund_outside_business_hour = warehouse.disable_deposit_refund_outside_business_hour;
		this.props.warehousesUpdate(data);

		let ipWhitelists = {
			warehouse_code: id,
			delete: true,
			whitelist: this.state.ipWhitelists.toJS(),
		};
		this.props.warehousesBatchUpdateIPWhitelists(ipWhitelists);
	}

	renderField(warehouse, field) {
		let value = field.id ? warehouse.get(field.id) : '';
		if (field.id === 'wh_type') {
			switch (value) {
			case 'C':
				value = 'Consignment';
				break;
			case 'S':
				value = 'Shop';
				break;
			case 'W':
				value = 'Warehouse';
				break;
			}
		}
		return (
			<FormGroup key={ `page-warehouse-form-group-${field.id}` }>
				<Label>{ field.label }:</Label>
				<h3>{ value }</h3>
			</FormGroup>
		);
	}

	renderSelect(field, isLoading) {
		const { warehouse } = this.state;
		const { errors } = this.props;
		const  options = this.props.options.get(field.id === 'stock_transfer_destinations' ? 'warehouse_groups' : field.id);

		if (field.type === 'checkbox') {
			return (
				<FormGroup key={ `page-warehouse-${field.id}` }>
					<Label for={ field.id }>{ field.label }</Label>

					{
						options && options.map((option, index) => (
							<CustomInput
								key={ `page-warehouse-${field.id}-${index}` }
								type="checkbox"
								id={ `${field.id}-${option.value}` }
								label={ option.label }
								value={ option.value }
								checked={ (warehouse.get(field.id) && warehouse.get(field.id).includes(option.value)) || false }
								onChange={ this.onChangeCheckboxHandler }
							/>
						))
					}

					{
						errors && errors.detail[field.id] && (
							<div className="invalid-feedback d-block">
								{
									errors && errors.detail[field.id].map((error, index) => (
										<Fragment key={ `custom-form-group-${field.id}-error-${index}` }>
											{ index > 0 && <br /> }
											{ error }
										</Fragment>
									))
								}
							</div>
						)
					}
				</FormGroup>
			);
		}

		return (
			<CustomFormGroup
				key={ `page-warehouse-${field.id}` }
				id={ field.id }
				label={ field.label }
				type="react-select"
				value={ field.id === 'warehouse_type' ? (warehouse.get(field.id) || { value: 'Not Boutique', label: 'Not Boutique' }) : warehouse.get(field.id) }
				disabled={ isLoading }
				errors={ errors && errors.detail[field.id] }
				onChange={ field.onChange }
				options={ options }
				isMulti={ field.isMulti }
			/>
		);
	}

	renderSwitch(field) {
		const { warehouse } = this.state;
		return (
			<FormGroup>
				<Label>{ field.label }</Label>
				<Switch
					className="custom-switch custom-switch-primary"
					checked={ warehouse.get(field.id) == '1' }
					onChange={ field.onChange }
				/>
			</FormGroup>
		);
	}

	render() {
		const { errors, errorsIPWhitelists } = this.props;
		const { warehouse, activeTab, showModalIP, ipWhitelists, currentIndex, modalData } = this.state;
		const status = this.props.status.get('warehouse');
		const ipWhitelistsStatus = this.props.status.get('ipWhitelists');
		const optionsStatus = this.props.status.get('options');
		const isLoading = status === 'fetching' || status === 'submitting' || ipWhitelistsStatus === 'fetching' || ipWhitelistsStatus === 'submitting' || optionsStatus === 'fetching';
		return (
			<Fragment>
				<Row>
					<Colxx xxs="12">
						<BreadcrumbContainer
							heading={
								<Fragment>
									<IntlMessages id="warehouse.heading" />: { warehouse.get('wh_desc') }
								</Fragment>
							}
							items={ this.breadcrumb }
							match={ this.props.match }
						/>
					</Colxx>
				</Row>

				<LoadingOverlay active={ isLoading }>
					<Nav tabs className="separator-tabs ml-0 mb-5">
						<NavItem>
							<NavLink
								className={ classnames({
									active: activeTab === 'details',
									'nav-link': true
								}) }
								onClick={ this.onSelectDetailsTabHandler }
								to="#"
							>
								DETAILS
							</NavLink>
						</NavItem>
						<NavItem>
							<NavLink
								className={ classnames({
									active: activeTab === 'businessHour',
									'nav-link': true
								}) }
								onClick={ this.onSelectBusinessHourTabHandler }
								to="#"
							>
								BUSINESS HOUR
							</NavLink>
						</NavItem>
						<NavItem>
							<NavLink
								className={ classnames({
									active: activeTab === 'ip',
									'nav-link': true
								}) }
								onClick={ this.onSelectIPTabHandler }
								to="#"
							>
								IP
							</NavLink>
						</NavItem>
						<NavItem>
							<NavLink
								className={ classnames({
									active: activeTab === 'emergency',
									'nav-link': true
								}) }
								onClick={ this.onSelectEmergencyTabHandler }
								to="#"
							>
								EMERGENCY
							</NavLink>
						</NavItem>
					</Nav>

					<TabContent activeTab={ activeTab }>
						<TabPane tabId="details">
							<Form>
								<Row>
									<Colxx md="6">
										<Card>
											<CardBody>
												{
													this.fields.details.map((field) => this.renderField(warehouse, field))
												}

												{
													this.fields.detailsInput.map((field) => (
														<CustomFormGroup
															key={ `page-warehouse-${field.id}` }
															id={ field.id }
															label={ field.label }
															type={ field.type }
															value={ warehouse.get(field.id) }
															disabled={ isLoading || (field.id === 'mall_name' && this.getWarehouseTypeValue(warehouse) !== 'Boutique') }
															errors={ errors && errors.detail[field.id] }
															onChange={ this.onChangeHandler }
														/>
													))
												}

												{ this.fields.detailsSelect.map((field) => this.renderSelect(field, isLoading)) }
											</CardBody>
										</Card>
									</Colxx>
									<Colxx md="6">
										<Card className="mb-4">
											<CardBody>
												{ this.fields.group.map((field) => this.renderSelect(field, isLoading)) }
											</CardBody>
										</Card>

										<Card className="mb-4">
											<CardBody>
												{ this.fields.document_type.map((field) => this.renderSelect(field, isLoading)) }
											</CardBody>
										</Card>

										<Card className="mb-4">
											<CardBody>
												{ this.fields.payment_method.map((field) => this.renderSelect(field, isLoading)) }
											</CardBody>
										</Card>

										<Card className="mb-4">
											<CardBody>
												{ this.fields.invoice_template.map((field) => this.renderSelect(field, isLoading)) }
											</CardBody>
										</Card>

										<Card>
											<CardBody>
												{ this.fields.detailsInvoice.map((field) => this.renderSwitch(field, isLoading)) }
											</CardBody>
										</Card>
									</Colxx>
								</Row>
							</Form>

							<div className="mt-4 mb-3 text-center">
								<Button color="primary" size="lg" onClick={ this.onSubmitHandler } disabled={ isLoading }>
									SAVE
								</Button>
							</div>
						</TabPane>
						<TabPane tabId="businessHour">
							<Card>
								<CardBody>
									<CardTitle>Out of Business Hour Restriction</CardTitle>
									{
										this.fields.business_hour.map((field) => {
											switch(field.type) {
											case 'switch':
												return this.renderSwitch(field);
											case 'title':
												return (
													<Fragment key={ `page-warehouse-${field.id}` }>
														<hr className="mt-4 mb-3" />
														<h4 className="mt-4 mb-3">{ field.label }</h4>
													</Fragment>
												);
											case 'time':
												return (
													<CustomFormGroup
														key={ `page-warehouse-${field.id}` }
														id={ field.id }
														label={ field.label }
														type={ field.type }
														value={ warehouse.get(field.id) }
														disabled={ isLoading }
														errors={ errors && errors.detail[field.id] }
														onChange={ this.onChangeHandler }
													/>
												);
											}
										})
									}
								</CardBody>
							</Card>
							<div className="mt-4 mb-3 text-center">
								<Button color="primary" size="lg" onClick={ this.onSubmitHandler } disabled={ isLoading }>
									SAVE
								</Button>
							</div>
						</TabPane>
						<TabPane tabId="ip">
							<Card>
								<CardBody>
									<CardTitle>IP Whitelist Control</CardTitle>
									<Table hover>
										<thead>
											<tr>
												<th width="30%">IP</th>
												<th width="35%">Description</th>
												<th width="15%">Status</th>
												<th width="20%"></th>
											</tr>
										</thead>
										<tbody>
											{
												ipWhitelists.map((ipWhitelist, index) => (
													<tr key={ `page-warehouse-ip-whitelist-${index}` }>
														<th>
															<h4 className={ classnames(errorsIPWhitelists && errorsIPWhitelists.detail[`whitelist.${index}.ip_address`] && 'text-danger') }>
																{ ipWhitelist.get('ip_address') }
															</h4>
															{
																errorsIPWhitelists && errorsIPWhitelists.detail[`whitelist.${index}.ip_address`] && (
																	<div className="text-danger">
																		{ errorsIPWhitelists.detail[`whitelist.${index}.ip_address`] }
																	</div>
																)
															}
														</th>
														<td>
															<h4 className={ classnames(errorsIPWhitelists && errorsIPWhitelists.detail[`whitelist.${index}.desc`] && 'text-danger') }>
																{ ipWhitelist.get('desc') }
															</h4>
															{
																errorsIPWhitelists && errorsIPWhitelists.detail[`whitelist.${index}.desc`] && (
																	<div className="text-danger">
																		{ errorsIPWhitelists.detail[`whitelist.${index}.desc`] }
																	</div>
																)
															}
														</td>
														<td>
															<Switch
																className="custom-switch custom-switch-primary"
																checked={ ipWhitelist.get('enabled') }
																onChange={ this.onToggleIPWhitelistHandler.bind(this, index) }
															/>
														</td>
														<td className="text-right">
															<Button size="sm" outline color="primary" className="mr-2" disabled={ isLoading } onClick={ this.onEditIPWhitelistHandler.bind(this, index) }>
																<i className="simple-icon-pencil btn-group-icon" />
															</Button>
															<Button size="sm" outline color="danger" disabled={ isLoading } onClick={ this.onDeleteIPWhitelistHandler.bind(this, index) }>
																<i className="simple-icon-close btn-group-icon" />
															</Button>
														</td>
													</tr>
												))
											}
										</tbody>
									</Table>
								</CardBody>
							</Card>

							<div className="mt-4 mb-3 text-center">
								<Button outline color="primary" size="lg" className="mr-2" onClick={ this.onToggleModalIPHandler } disabled={ isLoading }>
									ADD NEW
								</Button>
								<Button color="primary" size="lg" onClick={ this.onSubmitHandler } disabled={ isLoading }>
									SAVE
								</Button>
							</div>
						</TabPane>

						<TabPane tabId="emergency">
							<Card>
								<CardBody>
									<CardTitle>Emergency Control</CardTitle>

									{
										this.fields.emergency.map((field) => {
											switch (field.type) {
											case 'switch':
												return this.renderSwitch(field);
											case 'time':
												return (
													<CustomFormGroup
														key={ `page-warehouse-${field.id}` }
														id={ field.id }
														label={ field.label }
														type={ field.type }
														value={ warehouse.get(field.id) }
														disabled={ isLoading }
														errors={ errors && errors.detail[field.id] }
														onChange={ this.onChangeHandler }
													/>
												);
											case 'select':
												return this.renderSelect(field, isLoading);
											}
										})
									}
								</CardBody>
							</Card>

							<div className="mt-4 mb-3 text-center">
								<Button color="primary" size="lg" onClick={ this.onSubmitHandler } disabled={ isLoading }>
									SAVE
								</Button>
							</div>
						</TabPane>
					</TabContent>
				</LoadingOverlay>

				<Modal
					isOpen={ showModalIP }
					toggle={ this.onCancelModalIPHandler }
					wrapClassName="modal-right"
				>
					<ModalHeader>
						{ currentIndex === null ? 'New' : 'Edit' } IP
					</ModalHeader>
					<ModalBody>
						<Form onSubmit={ this.onConfirmModalIPHandler }>
							<FormGroup>
								<Label>IP Address</Label>
								<Input
									type="text"
									value={ modalData.get('ip_address') || '' }
									disabled={ isLoading }
									onChange={ this.onChangeModalIPAddressHandler }
								/>
							</FormGroup>
							<FormGroup>
								<Label>Description</Label>
								<Input
									type="text"
									value={ modalData.get('desc') || '' }
									disabled={ isLoading }
									onChange={ this.onChangeModalDescHandler }
								/>
							</FormGroup>
							<FormGroup>
								<Label>Status</Label>
								<Switch
									className="custom-switch custom-switch-primary"
									checked={ modalData.get('enabled') }
									onChange={ this.onChangeModalStatusHandler }
								/>
							</FormGroup>
						</Form>
					</ModalBody>
					<ModalFooter>
						<Button outline color="primary" onClick={ this.onCancelModalIPHandler } disabled={ isLoading }>
							Cancel
						</Button>
						<Button color="primary" onClick={ this.onConfirmModalIPHandler } disabled={ isLoading }>
							Submit
						</Button>
					</ModalFooter>
				</Modal>
			</Fragment>
		);
	}
}

export default connect(
	warehousesReducer.selector,
	{
		warehousesUpdate,
		warehousesGetDetails,
		warehousesGetOptions,
		warehousesGetIPWhitelists,
		warehousesBatchUpdateIPWhitelists,
		errorReset,
	}
)(PageWarehouse);
